import React from 'react';
import { bool, func } from 'prop-types';
import { eventNames, reportToSegment, types } from '@smartcar/morse';
import { Button, Typography } from '@mui/material';

import { Modal } from '../../../../../../../../components';
import staticText from '../../../../../../../../localization/Application/webhooks';

const EarlyExitModal = ({
  showExitModal,
  setShowExitModal,
  toggleWebhookModal,
}) => {
  const addModalText = staticText.addModal;

  const handleActionClick = (action) => {
    reportToSegment(types.TRACK, eventNames.buttonClicked, {
      label: 'action',
      text: `[add webhook form] - ${action === 'cancel' ? addModalText.exitModal.cancel : addModalText.exitModal.confirm}`,
    });
    if (action === 'cancel') {
      setShowExitModal(false);
    } else if (action === 'confirm') {
      toggleWebhookModal({ nextModal: '', curModal: '' });
    }
  };

  return (
    <Modal
      title={addModalText.exitModal.title}
      content={
        <Typography>{addModalText.exitModal.description}</Typography>
      }
      toggleModal={() => setShowExitModal(!showExitModal)}
      actions={
        <React.Fragment>
          <Button
            variant="outlined"
            name={addModalText.exitModal.cancel}
            onClick={() => handleActionClick('cancel')}
          >{addModalText.exitModal.cancel}
          </Button>
          <Button
            variant="outlined"
            name={addModalText.exitModal.confirm}
            color="error"
            onClick={() => handleActionClick('confirm')}
          >{addModalText.exitModal.confirm}
          </Button>
        </React.Fragment>
      }
    />
  );
};

export default EarlyExitModal;

EarlyExitModal.propTypes = {
  showExitModal: bool.isRequired,
  setShowExitModal: func.isRequired,
  toggleWebhookModal: func.isRequired,
};
